window.$ = window.jQuery = require('jquery');

//Amcharts
require('./vendor/amcharts/core');
require('./vendor/amcharts/charts');
require('./vendor/amcharts/maps');
require('./vendor/amcharts/geodata/swedenHigh');
require('./vendor/amcharts/themes/animated');
//Modules
require('./modules/set-image-caption');
require('./modules/set-quote-cite');
require('./modules/mobile-menu');
require('./modules/responsive-tables');
require('./modules/calendar');
require('./modules/check-long-titles');
require('./modules/clearable-input');
require('./modules/collapse');
require('./modules/show-more');
require('./modules/listing-block');
require('./modules/notes-and-coins');
require('./modules/image-popup');
require('./modules/helper-text');
require('./modules/header-search');
require('./modules/interest-forms'); // TODO Can possible be removed when new "Sök räntor och valutakurser" are in place.
require('./modules/cross-rates'); // TODO Can possible be removed when new "Sök räntor och valutakurser" are in place.
// Start New sök räntor och valuta kurser
require('./modules/interest-page-astrid'); // New
require('./modules/interest-month-year-astrid'); // New
require('./modules/cross-rates-astrid'); // New
require('./modules/duet-date-picker'); // New datepicker
// End New sök räntor och valuta kurser
require('./modules/swea-datepickers'); // TODO Old datepicker conf can possible be removed when new new datepicker is implemented
require('./modules/data-block');
require('./modules/rbplay');
require('./modules/header-search');
require('./modules/livestream-block');
require('./modules/sticky-sidebar');
require('./modules/scrollspy');
require('./modules/cookie-handler');
require('./modules/copy-url-to-clipboard');
require('./modules/listing-filter-block');
require('./modules/iframe');
require('./modules/object-fit');
require('./modules/position-inline-article-images');
require('./modules/tracking');
require('./modules/detect-tabbing');
// require('./modules/fonts');
require('./modules/riksbank-series-form');
require('./modules/bank-id-form');
require('./modules/search-autocomplete');
require('./modules/epi-forms');
require('./modules/image-slider');
require('./modules/video-embed');
require('./modules/tora-form');
require('./modules/graph-block/localization-se');
require('./modules/graph-block/index');
require('./modules/was-this-page-helpful');
require('./modules/report-footnote');
require('./modules/tooltip/index');
require('./modules/report-content-loader');
require('./modules/report-description');
require('./modules/report-mobile-menu');
require('./modules/report-import-status');
require('./modules/set-focus-handler');

// Vendor
// TODO: webpack - All other vendor files are copied in webpack.common - dont know why this one is not loaded. Datepicker is a place to look for error
require('./vendor/jquery-ui.min.js');

// Remove preloaded styling
$(function () {
    $('.js-preload-style').removeClass('js-preload-style');

	var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
	if (!supportsTouch) {
		$('body').addClass('no-touch');
	}
});
